import {
  Box,
  Dialog,
  useTheme,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
} from "@mui/material";
import { Button } from "@mui/material";
import { Paper } from "@mui/material";
import { Grid } from "@mui/material";
import { Typography } from "@mui/material";
import { PageContainer } from "../../components/container/PageContainer";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PageLoader } from "../../components/PageLoader/PageLoader";
import { useAuth } from "../../contexts/AuthProvider/AuthProvider";
import { showMessage } from "../../redux/messages/messagesActions";
import { useDispatchWrapper } from "../../hooks";
import {
  getSubscriptionPlan,
  getSubscriptionPlanByUuid,
  upsertUserSubscription,
} from "../../services/subcriptionApi";
import SubscriptionCard from "./components/SubscriptionCard";
// import { mockdata } from "./components/constant";
import {
  BillingCompanyProvider,
  useBillingCompanyContext,
} from "../../providers";
import { Congratulations } from "./components/congratulations";
import { ISubscriptionPlan } from "../../redux/subscription/subscription.types";
import Navbar from "../authentication/Navbar";
import LoadingDialog from "../../components/Dialogs/LoadingDialog";

export const ChooseSubscription: React.FC = () => {
  const navigate = useNavigate();
  const planType = ["All", "Days", "Months", "Years"];
  const [selectedPlanType, setSelectedPlanType] = useState<string>("All");
  const [viewMore, setViewMore] = useState<boolean>(false);
  const [planLoading, setPlanLoading] = useState<boolean>(false);
  const [viewPlan, setViewPlan] = useState<ISubscriptionPlan | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [allPlan, setAllPlan] = useState<ISubscriptionPlan[]>([]);
  const [showDialog, setShowDialog] = useState<boolean>(false);
  const session = useAuth();
  const theme = useTheme();
  const dispatch = useDispatchWrapper();
  const companyOutlet = useBillingCompanyContext();

  const fetchPlans = async () => {
    try {
      setPlanLoading(true);
      const response = await getSubscriptionPlan(selectedPlanType);
      setAllPlan(response || []);
    } catch (err: any) {
      console.error("Error fetching subscription plans:", err);
      dispatch(
        showMessage({
          type: "error",
          message:
            err.response?.data?.message || "Failed to fetch subscription plans",
          displayAs: "snackbar",
        })
      );
    } finally {
      setPlanLoading(false);
    }
  };

  useEffect(() => {
    fetchPlans();
  }, [selectedPlanType]);

  async function handleChoosePlan(plan: ISubscriptionPlan) {
    try {
      setLoading(true);
      const user_uuid = session.user.userUuid;

      if (!user_uuid) {
        dispatch(
          showMessage({
            type: "error",
            message: "Please login to select a subscription plan",
            displayAs: "snackbar",
          })
        );
        setLoading(false);
        return;
      }
      const response = await upsertUserSubscription(
        plan.subscription_plan_uuid || "",
        companyOutlet.comapny.company_outlet_uuid,
        "PAID"
      );
      if (response && response?.status === 404) {
        dispatch(
          showMessage({
            type: "error",
            message: response.data.message,
            displayAs: "snackbar",
          })
        );
        navigate("/auth/dashboard");
      }
      if (response && response?.status === 200) {
        setShowDialog(true);
        setViewPlan(plan);
      }
      setLoading(false);
    } catch (err: any) {
      setLoading(false);
      console.error("Error choosing plan:", err);
      dispatch(
        showMessage({
          type: "error",
          message: err.response?.data?.message || "Failed to subscribe to plan",
          displayAs: "snackbar",
        })
      );
      if (err.response && err.response.data && err.response.data.message) {
        console.log(err.response.data.message);
      }
    }
  }

  return (
    <>
      <PageLoader loading={loading}>
        <PageContainer title="Subscription" description="Subscription">
          <Navbar />
          <Box
            sx={{
              width: "100%",

              px: 4,
              pb: 4,
              pt: 10,
              minHeight: "100vh",
            }}
          >
            <Typography
              variant="h3"
              component="h1"
              textAlign="center"
              sx={{
                mb: 2,
                fontWeight: "bold",
                color: "#333",
                fontSize: "2rem",
              }}
            >
              <span style={{ color: theme.palette.primary.dark }}>
                Pricing plans
              </span>{" "}
              to fuel your success
            </Typography>
            <Typography
              variant="body1"
              textAlign="center"
              sx={{
                mb: 2,
                fontSize: "1rem",
                color: "#666",
                maxWidth: "600px",
                mx: "auto",
              }}
            >
              Access the features that power your conversations with the right
              context, data, and customer insights.
            </Typography>
            <Box
              sx={{
                width: "100%",

                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {planLoading ? (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "300px",
                    gap: 2,
                  }}
                >
                  <CircularProgress size={50} />
                  <Typography variant="body1" color="text.secondary">
                    Loading subscription plans...
                  </Typography>
                </Box>
              ) : (
                <Box
                  sx={{
                    width: "90%",
                    ml: 6,
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, 22rem)",
                    gap: 6,
                    marginTop: 5,
                    justifyContent: "center",
                    alignItems: "stretch",
                  }}
                >
                  {allPlan?.map((plan, index) => (
                    <SubscriptionCard
                      key={index}
                      plan={plan}
                      handleChoosePlan={handleChoosePlan}
                      cardButtonText="Start Free Trial"
                    />
                  ))}
                </Box>
              )}
            </Box>
          </Box>
        </PageContainer>
      </PageLoader>
      {showDialog && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 1000,
            backgroundColor: "#fff",
          }}
        >
          <Congratulations viewPlan={viewPlan} />
        </Box>
      )}
    </>
  );
};
